import $ from 'jquery';

export default angular.module('cian.newbuild.filter.stickyFilters', [])
  .directive('stickyFilters', [
    '$window',
    'BrowserInfo',
    ($window, BrowserInfo) => {
      return {
        restrict: 'A',
        link: (scope, $filtersEl) => {
          const STATES = {
            INITIAL: 'INITIAL',
            HIDDEN: 'HIDDEN',
            FIXED: 'FIXED',
          };

          const CLASSES = {
            HIDDEN: 'is-hidden',
            FIXED: 'is-fixed',
            NO_TRANSITION: 'no-transition',
            SUPPORTS_STICKY: 'supports-sticky',
          };

          const DIRECTION_CHANGE_DELTA = 75;

          const $windowEl = $($window);
          const $documentEl = $($window.document);
          let lastScrollTop = $windowEl.scrollTop();
          let currentState = STATES.INITIAL;
          let wasScrollingUp;
          let posWhereDirectionChanged;

          $filtersEl.toggleClass(CLASSES.SUPPORTS_STICKY,
            BrowserInfo.supportsCSS('position', 'sticky'));

          $windowEl.on('scroll.stickyFilters', detectState);
          scope.$on('$destroy', () => $windowEl.off('scroll.stickyFilters', detectState));
          detectState();

          function detectState() {
            // Определяем направление скролла
            const scrollTop = $windowEl.scrollTop();
            const scrollingDown = scrollTop > lastScrollTop;
            const scrollingUp = scrollTop < lastScrollTop;
            const maxScrollTop = $documentEl.height() - $windowEl.height();

            // Скролл может выйти за рамки страницы при инертном скролле на Маке и iOS
            if (scrollTop >= maxScrollTop) return;

            // Определяем видимость фильтров
            const filtersTop = $filtersEl.parent().offset().top;
            const filtersHeight = $filtersEl[0].getBoundingClientRect().height;
            const areFiltersVisible = scrollTop <= filtersTop + filtersHeight;

            // При скролле тачпадом движение может заканчиваться небольшим скроллом в обратную сторону
            // Чтобы предотвратить это, не меняем состояние сразу после смены направления
            if (scrollingUp !== wasScrollingUp) {
              posWhereDirectionChanged = scrollTop;
              wasScrollingUp = scrollingUp;
            }
            const directionJustChanged =
              Math.abs(scrollTop - posWhereDirectionChanged) < DIRECTION_CHANGE_DELTA;

            switch (currentState) {
              case STATES.INITIAL:
                if (!areFiltersVisible) {
                  switchState(STATES.HIDDEN);
                }
                break;

              case STATES.HIDDEN:
                if (!directionJustChanged && scrollingUp) switchState(STATES.FIXED);
                break;

              case STATES.FIXED:
                if (scrollingUp && scrollTop <= filtersTop) {
                  switchState(STATES.INITIAL);
                  break;
                }
                if (!directionJustChanged && scrollingDown && !areFiltersVisible) {
                  switchState(STATES.HIDDEN);
                  break;
                }
                break;
            }

            lastScrollTop = scrollTop;
          }

          function switchState(newState) {
            switch (newState) {
              case STATES.INITIAL:
                $filtersEl.removeClass(CLASSES.FIXED);
                break;

              case STATES.HIDDEN:
                // Симулируем клик, чтобы закрылись дропдауны
                $filtersEl[0].click();
                $filtersEl
                  .toggleClass(CLASSES.NO_TRANSITION, currentState === STATES.INITIAL)
                  .addClass(CLASSES.FIXED)
                  .addClass(CLASSES.HIDDEN);
                break;

              case STATES.FIXED:
                $filtersEl
                  .addClass(CLASSES.FIXED)
                  .removeClass(CLASSES.NO_TRANSITION)
                  .removeClass(CLASSES.HIDDEN);
                break;
            }
            currentState = newState;
          }
        },
      };
    }])
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/sticky-filters.dir.js